import { AuthLayout } from '../../components';
import { Link } from 'react-router-dom';
import DynamicFaIcon from '../../components/atoms/DynamicFaIcon';

const ResetPasswordSuccess = () => {

    return (
        <AuthLayout showNavBar={false}>
            <div className="w-full flex justify-center mt-20">
                <img src="/assets/imgs/icon-pass-success.png" alt="" />
            </div>
            <div className="w-full justify-center text-center mt-5">
                <h2 className="text-[20px] font-bold">Reset Password Berhasil</h2>
                <h4 className="text-[12px]">You can now log in to your account </h4>
            </div>
            <div className="w-full flex justify-center items-center mt-6">
                <Link to={'/auth'} className='flex items-center'>
                    <DynamicFaIcon name={"FaArrowLeft"} />
                    <span className='text-primary text-[12px] font-bold ml-2'>Login Now</span>
                </Link>
            </div>
        </AuthLayout>
    );
};

export default ResetPasswordSuccess;